export enum STATUS {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
}

export enum PRIORITY {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum ALERT_AUDIT_ACTION {
  OPTION_SELECTED = 'OPTION_SELECTED',
  RESOLUTION_SELECTED = 'RESOLUTION_SELECTED',
  ALERT_RESOLVED = 'ALERT_RESOLVED',
}
